import { App, type URLOpenListenerEvent } from "@capacitor/app";
import { isNative } from "./platform";

type NavigateFn = (path: string) => void;

/**
 * Universal Links (iOS) / App Links (Android) / custom-scheme deep links.
 *
 * Handles:
 *   https://theworkitect.com/app/task/:id
 *   https://theworkitect.com/app/approval/:token
 *   https://theworkitect.com/app/intake/:formId
 *   com.workitect.app://<path>
 */
export function initDeepLinks(navigate: NavigateFn): () => void {
  if (!isNative()) return () => {};

  const handle = (event: URLOpenListenerEvent) => {
    try {
      const url = new URL(event.url);
      // Custom scheme collapses host+path — treat pathname as source of truth.
      const path =
        url.protocol === "com.workitect.app:"
          ? `/${url.host}${url.pathname}`.replace(/\/+/g, "/")
          : url.pathname + url.search;

      if (path && path !== "/") navigate(path);
    } catch (err) {
      console.warn("[deepLinks] invalid url", event.url, err);
    }
  };

  const handlePromise = App.addListener("appUrlOpen", handle);
  return () => {
    void handlePromise.then((h) => h.remove());
  };
}
